// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tuition-express-modal{width:400px}.tuition-express-modal .modal__container{margin:20px -10px -10px}`, "",{"version":3,"sources":["webpack://./src/modals/TuitionExpressCard/style.scss"],"names":[],"mappings":"AACA,uBACE,WAAA,CAEA,yCACE,uBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
